import { EventEmitter, Output, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SearchProvider {
  @Output() public onFind: EventEmitter<any> = new EventEmitter();
  @Output() public onFindUp: EventEmitter<any> = new EventEmitter();
  @Output() public onFindDown: EventEmitter<any> = new EventEmitter();
  constructor() {}
}
